<div mat-dialog-content style="max-height: none; text-align: center">
  <button mat-icon-button (click)="close()" aria-label="Close gallery" style="position: absolute; right: 0; top: 0">
    <icon icon="close" />
  </button>
  <button mat-icon-button (click)="left()" aria-label="Previous image" style="position: absolute; left: 0; top: 50%">
    <icon icon="chevron_left" />
  </button>
  <button mat-icon-button (click)="right()" aria-label="Next image" style="position: absolute; right: 0; top: 50%">
    <icon icon="chevron_right" />
  </button>
  <img
    cdkFocusInitial
    [src]="gallery()[selected()] | imageUrl: namespace()"
    (error)="onImgError($event)"
    style="height: calc(90vh - 40px); width: auto; max-width: 100%" />
</div>
